import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/AVM_Fritzbox_Portweiterleitung_Freigabe_einrichten.mp4" />
        </Player>
        <EuiText>
            <p>AVM Fritzbox Portweiterleitung / Freigabe einrichten. Auf <OutboundLink href="https://www.youtube.com/watch?v=sO11LJz886c" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard